;(function() {
    const {
        request: {
            pageType
        },
        shop,
        settings
    } = window.themeVariables;

    if (pageType === 'index') {
        const { storeReviews } = window.WATERDROP;

        const richScript = document.createElement('script');
        richScript.setAttribute('type', 'application/ld+json');

        const data = {
            "@context": "https://schema.org",
            "@type": "Corporation",
            "name": "waterdrop®",
            "url": shop.url,
            "description": shop.description,
            "logo":"//ae.waterdrop.com/cdn/shopifycloud/shopify/assets/no-image-100-c91dd4bdb56513f2cbf4fc15436ca35e9d4ecd014546c8d421b1aece861dfecf_small.gif",
            "address": {
                "@type": "PostalAddress",
                "streetAddress": "Laimgrubengasse 14",
                "addressLocality": "Wien",
                "addressCountry": "Austria",
                "postalCode": "1060"
            },
            "email": `mailto: ${shop.email}`,
            "telephone": "0043 800 6566500",
            "sameAs": [
                "https://www.facebook.com/officialwaterdrop",
                "https://twitter.com/drink_waterdrop",
                "https://www.instagram.com/waterdrop",
                "https://www.youtube.com/channel/UCLSHvdLFujUObZk1Yn7K6Dg",
                "https://www.linkedin.com/company/waterdrop-official",
                "https://www.pinterest.at/waterdrop",
                "https://vm.tiktok.com/ZMJSAneY9"
            ]
        }

        if (storeReviews && Object.keys(storeReviews).length > 0) {
            data['aggregateRating'] = {
                "@type": "AggregateRating",
                "ratingValue": storeReviews.ratingValue,
                "reviewCount": storeReviews.reviewCount,
                "bestRating": storeReviews.bestRating
            }
        }

        richScript.textContent = JSON.stringify(data);
        document.body.appendChild(richScript);
    }

    if (pageType === 'product') {

        const { product, product_metafields, productReviews } = window.WATERDROP;
        const richScript = document.createElement('script');
        richScript.setAttribute('type', 'application/ld+json');

        let data = [];
        const url = new URL(window.location.href);
        const searchParams = url.searchParams;
        let variantId = searchParams.get('variant');
        let variant

        //select the variant via url parameter - adjust the structured data to use the selected variant
        if(variantId) {
            let variants = product.variants.filter(variant => variant.id == variantId);

            if(variants && variants.length>0){
                variant = variants[0];
                data['offer.url'] = location.host + "/products/" + product.handle + "?variant=" + variant.id + "&currency=" + settings.cartCurrency;
                data['offer.price'] = Shopify.formatMoney(variant.price).replace(/[^0-9.]/g, '');
                data['offer.availability'] = variant.available ? "https://schema.org/InStock" : "https://schema.org/OutOfStock";
                data['offer.productID'] = variant.id;

                data['product.gtin'] =  variant.barcode ?? "";
                data['product.sku'] =  variant.sku;
                data['product.productID'] = variant.id;
                data['product.image.url'] = variant.featured_image?.src;
            }
        }
        //if no data exists there was no variant in the URL
        //take the product - product without variants found
        if(!data['offer.url']){
            data['offer.url'] = location.host + "/products/" + product.handle + "?currency=" + settings.cartCurrency;
            data['offer.price'] = Shopify.formatMoney(product.price).replace(/[^0-9.]/g, '');
            data['offer.availability'] = product.variants[0].available ? "https://schema.org/InStock" : "https://schema.org/OutOfStock";
            data['offer.productID'] = product.variants[0].id;

            data['product.gtin'] =  product.variants[0].barcode ?? "";
            data['product.sku'] =  product.variants[0].sku;
            data['product.productID'] = product.variants[0].id;
            data['product.url'] = location.host + "/products/" + product.handle + "?currency=" + settings.cartCurrency;
            data['product.image.url'] = product.featured_image;
        }
        data['offer.priceCurrency'] = settings.cartCurrency
        data['product.name'] =  product.title + " " + product_metafields.subtitle;
        data['product.description'] =  product.description.replace(/(<([^>]+)>)/gi, "");
        data['product.category'] =  product.type;
        data['product.inProductGroupWithID'] =  product.id;
        data['product.image.name'] =  product.title;

        if (productReviews && Object.keys(productReviews).length > 0) {
            data['product.ratingValue'] = productReviews.ratingValue;
            data['product.reviewCount'] = productReviews.reviewCount;
            data['product.bestRating'] = productReviews.bestRating;
        }

        let offer = getProductOffersObject(data);
        let productObject = getProductObject(data,offer);

        richScript.textContent = JSON.stringify(productObject);
        document.body.appendChild(richScript);
    }
})();

function getProductObject(data, offers){
    const rawData = {
        "@context": "https://schema.org",
        "@type": "Product",
        "gtin":data['product.gtin'],
        "name": data['product.name'],
        "description": data['product.description'],
        "category": data['product.category'],
        "url": data['product.url'], //variant url including currency
        "sku": data['product.sku'],
        "productID": data['product.productID'],
        "inProductGroupWithID" : data['product.inProductGroupWithID'],
        "brand": {
            "@type": "Brand",
            "name": "waterdrop®"
        },
        "image": {
            "@type": "ImageObject",
            "url": data['product.image.url'],
            "name": data['product.image.name'],
        },
        offers
    };

    if(data['product.ratingValue']){
        rawData['aggregateRating'] = {
            "@type": "AggregateRating",
            "ratingValue": data['product.ratingValue'],
            "reviewCount": data['product.reviewCount'],
            "bestRating": data['product.bestRating']
        }
    }

    return rawData;
}

function getProductOffersObject(data){
    let offers = [];
    offers.push(
        {
            "@type": "Offer",
            "url": data['offer.url'] ,
            "price": data['offer.price'],
            "priceCurrency": data['offer.priceCurrency'],
            "availability":  data['offer.availability']
        }
    )
    return offers;
}
